import React, { useEffect } from 'react';
import { EditorialVariant } from './components/EditorialVariant';
export function App() {
  useEffect(() => {
    const w = window as any;
    if (w.__metaPixelInitialized) return;
    w.__metaPixelInitialized = true;
    w.fbq = w.fbq || function () {
      w.fbq.callMethod ? w.fbq.callMethod.apply(w.fbq, arguments) : w.fbq.queue.push(arguments);
    };
    if (!w._fbq) w._fbq = w.fbq;
    w.fbq.push = w.fbq;
    w.fbq.loaded = true;
    w.fbq.version = '2.0';
    w.fbq.queue = w.fbq.queue || [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const head = document.head || document.getElementsByTagName('head')[0] || document.documentElement;
    head.appendChild(script);
    w.fbq('init', '1029238155326534');
    w.fbq('track', 'PageView');
  }, []);
  return <EditorialVariant data-id="element-0" />;
}